import { render, staticRenderFns } from "./creatives.vue?vue&type=template&id=2cf63f3a&"
import script from "./creatives.vue?vue&type=script&lang=js&"
export * from "./creatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports